(ns app.front.view.group.admin.inspections.instructions
  (:require [app.front.entities :as entities]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::save-changes
  (fn [_ [_ group-id value]]
    {:comm/command {:command    :group/save-rich-text-value
                    :method     :post
                    :data       (util/mmap {:group/inspection-request-instructions value}
                                           group-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :inspection/request-instructions-saved}}}))

(defn view [{:keys [tr]}]
  (let [{:group/keys [inspection-request-instructions] :as group} (<sub [::gas/group])]
    [acommon/form {:title       (tr [:inspection/request-instructions-title])
                   :legend-text (tr [:inspection/request-instructions-info])}
     [:div.flex
      [:div.w-full.lg:w-4-5.xl:w-2-3.xxl:w-1-2
       [ui-rt/editor-legacy {:id            (str (:db/id group) "-inspection-request-info-editor")
                             :initial-value inspection-request-instructions
                             :on-blur       #(>evt [::save-changes (:db/id group) %])}]]]]))
